import { CapabilityIdEnum } from 'src/app/shared/capabilities-and-permissions';

/**
 * The angularjs states related to the module Engagement
 */
engagementStates.$inject = ['$stateProvider'];
export function engagementStates($stateProvider) {
  $stateProvider
    .state('auth.alcmeon.engagement', {
      url: '/engagement',
      abstract: true,
      resolve: {
        canAccess: ['$state', '$q', 'UserFactory', 'sites', 'AngularAlcmeonContextService', function ($state, $q, UserFactory, sites, AngularAlcmeonContextService) {
          if (!UserFactory.hasCapabilityForAtLeastOneEnabledSite(CapabilityIdEnum.Engagement) || !AngularAlcmeonContextService.isEngagement()) {
            $state.go('auth.alcmeon.fuse.audience');
            return $q.reject();
          }
          return $q.resolve(true)
        }],
      },
    })
    .state('auth.alcmeon.engagement.send-message', {
      url: '/send-message',
      abstract: true,
    })
    .state('auth.alcmeon.engagement.send-message.search', {
      url: '/search',
      views: {
        'container@auth': {
          template: '<angular-engagement-wrapper></angular-engagement-wrapper>'
        }
      },
    })
    .state('auth.alcmeon.engagement.send-message.user-external-id', {
      url: '/sites/{siteId:int}/user-external-id/{userExternalId}',
      views: {
        'container@auth': {
          template: '<angular-engagement-wrapper></angular-engagement-wrapper>'
        }
      },
    })
    .state('auth.alcmeon.engagement.history', {
      url: '/history',
      views: {
        'container@auth': {
          template: '<angular-engagement-history></angular-engagement-history>',
        }
      }
    })
    ;
}
